import { useCommitteeScopeContext } from '../contexts/CommitteeScopeContext'

export function useCommitteeScope() {
  return useCommitteeScopeContext()
}
